import React, {useMemo} from "react";
import {AxiosError} from "axios";
import {SiteBunnyError} from "../../error";
import ErrorView from "./ErrorView";
import {useIntl} from "react-intl";

const ErrorFallback: React.FC<{error: Error, resetErrorBoundary: (...args: Array<unknown>) => void}> = ({error, resetErrorBoundary}) => {
    const intl = useIntl();

    const axiosError = useMemo(() => {
        if ('isAxiosError' in error) {
            const axiosError = error as AxiosError
            if (axiosError.isAxiosError) {
                return axiosError;
            }
        }

        return null;
    }, [error]);

    const siteBunnyError = useMemo(() => {
        if ('isSiteBunnyError' in error) {
            const _siteBunnyError = error as SiteBunnyError
            if (_siteBunnyError.isSiteBunnyError) {
                return _siteBunnyError;
            }
        }

        return null;
    }, [error]);

    const code = useMemo(() => {
        if (axiosError) {
            return axiosError.response?.statusText;
        }
        else if (siteBunnyError) {
            return siteBunnyError.code;
        }

        return null;
    }, [axiosError, siteBunnyError]);

    if (code === "403") {
        return (
            <ErrorView code={code}
                       title={intl.formatMessage({id: "e0001"})}
                       description={intl.formatMessage({id: "e0002"})}
                       resetErrorBoundary={resetErrorBoundary}
            />
        )
    } else if (code === "404") {
        return (
            <ErrorView code={code}
                       title={intl.formatMessage({id: "e0003"})}
                       description={intl.formatMessage({id: "e0004"})}
                       resetErrorBoundary={resetErrorBoundary}
            />
        )
    } else {
        return (
            <ErrorView code="500"
                       title={intl.formatMessage({id: "e0009"})}
                       description={intl.formatMessage({id: "e0010"})}
                       resetErrorBoundary={resetErrorBoundary}
            />
        )
    }
}

export default ErrorFallback;
